import { gql } from "graphql.macro";

export const USER_PROFILE_FRAGMENT = gql`
  fragment UserProfile on User {
    __typename
    id
    gender
    dateOfBirth
    bio
    nationality
    verified
    locationText
    profileImage {
      url
    }
    mediaList {
      __typename
      ... on UserProfileImage {
        image {
          url
        }
      }
      ... on UserCoverImage {
        image {
          url
        }
      }
      ... on UserMapImage {
        image {
          url
        }
      }
    }
  }
`;

export const MY_PROFILE = gql`
  fragment MyProfile on Me {
    __typename
    user {
      ...UserProfile
    }
    email
    preferredCurrency
    privacySettings {
      email
    }
  }
`;

export const ME_QUERY = gql`
  ${USER_PROFILE_FRAGMENT}
  ${MY_PROFILE}

  query MeQuery {
    me {
      id
      __typename
      ... on Me {
        ...MyProfile
      }
      ... on GuestMe {
        preferredCurrency
      }
    }
  }
`;
